// @flow
import React from 'react';
import { FormField } from './partials';

import { FieldRow } from './partials/FormComponents';

type Props = {
  field: Object
};

export const FieldForm = ({ field }: Props) => (
  <FormField>
    <FieldRow field={field} />
  </FormField>
);
